import { defineStore } from 'pinia'
import { type Ref, ref, watchEffect } from 'vue'
import type { InventoryMapInfoType } from '@/entities/Inventory/Main'
import { useLoadInventMapInfo } from './api.ts'
import { cloneDeep, sortBy } from 'lodash'

export const useInventoryMapInfo = defineStore('inventory_map_info', () => {
  const data = ref<InventoryMapInfoType[]>([])

  /**
   * Функция загрузки данных
   */
  const loadData = (ids: Ref<number[]>) => {
    const result = useLoadInventMapInfo(ids)

    watchEffect(() => {
      if (result.data.value) {
        data.value = cloneDeep(result.data.value.data || [])
        data.value = sortBy(data.value, ['object_type.icon'])
      }
    })

    return result
  }

  return {
    data,

    loadData,
  }
})
